export default {"src":"/_next/static/media/chevronRightBrandDark_16.4c0a062c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};